import React from 'react';
import { IconsPros } from './types';

/**
 * Box Icon component
 *
 * @returns JSX.ELEMENT
 */
export const BoxIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 128 128" data-testid={dataTestId}>
      <path
        d="M108 0H21C9 0 0 9 0 20v89c0 11 9 19 21 19h87c11 0 20-8 20-19V20c0-11-9-20-20-20zM67 93h-2l24-57h2L67 93zm28-57v6L71 93h-2l26-57zm-16 0L54 93h-2l25-57h2zm-4 0L50 93h-2l25-57h2zm-8 0L42 93h-2l25-57h2zm-4 0L38 93h-2l25-57h2zM33 93v-2l24-55h2L33 93zm20-57h2L33 86v-4l20-46zM33 77v-4l16-37h2L33 77zm14-41L33 68v-5l12-27h2zm-10 0h2l-6 14v-5l4-9zm-4 5v-5h2l-2 5zm8-5h2L33 58v-4l8-18zm-9-8h-7v7h7v-7zm0 66v7h-7v-7m19-1l25-57h2L46 93h-2zm13 0l24-57h2L59 93h-2zm28-57h2L63 93h-2l24-57zM73 93l22-47v4L75 93m4 0h-2l18-38v4L79 93zm16-29v4L83 93h-2l14-29zm-9 29l9-21v5l-7 16h-2zm9-11v5l-3 6h-2l5-11zm0 10v1h-1l1-1zm1 2h7v7h-7m0-74h7v7h-7v-7z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M66 31h9m7 0h9m-39 0h9m-24 0h9m20 66h9m7 0h9m-39 0h9m-24 0h9M28 67v9m0 6v9m0-39v9m0-23v9m71 20v9m0 6v9m0-39v9m0-23v9"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
